import script from "./CaskDialogImage.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskDialogImage.vue?vue&type=script&setup=true&lang=js"

import "./CaskDialogImage.vue?vue&type=style&index=0&id=2066abec&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
